@if (loading()) {
  <mat-progress-spinner [diameter]="20" color="accent" mode="indeterminate" />
} @else if (displayErrorMessage()) {
  <span class="grid-cell--error-message">{{ errorMessage() }}</span>
} @else {
  <span>{{ dataToDisplay() | infoDisplay }}</span>
}
